// extracted by mini-css-extract-plugin
export default {"trainers":"trainers_trainers__ursfF","trainers_head":"trainers_trainers_head__aXzks","boxes":"trainers_boxes__LZ79t","box":"trainers_box__2hLap"};